<template>
  <v-card
    class="px-3"
    flat
    tile
  >
    <v-row dense>
      <v-col>
        <span class="text-body-1 font-weight-bold grey--text text--darken-3">
          {{ $t("m.vesselBase") }}
        </span>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-text-field
          dense
          outlined
          hide-details="true"
          v-model="$store.state.vessel.baseForm.ShipName"
          :label="$t('m.shipName')"
        />
      </v-col>
      <v-col>
        <v-select
          :items="shipTypeArr"
          :label="$t('m.vesselType')"
          outlined
          dense
          hide-details="true"
          v-model="$store.state.vessel.baseForm.ShipType"
          item-text="DICTNAME"
          item-value="DICTID"
        />
      </v-col>
      <v-col>
        <v-select
          :items="countryArr"
          :label="$t('m.flag')"
          outlined
          dense
          hide-details="true"
          v-model="$store.state.vessel.baseForm.Flag"
          item-text="COUNTRYNAME"
          item-value="COUNTRYCODE"
        />
      </v-col>
      <v-col>
        <v-select
          :items="buildYearArr"
          :label="$t('m.builtYear')"
          outlined
          dense
          hide-details="true"
          v-model="$store.state.vessel.baseForm.BuildYear"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-text-field
          dense
          outlined
          hide-details="true"
          v-model="$store.state.vessel.baseForm.DWT"
          type="number"
          :label="$t('m.dwt')"
          :suffix="$t('m.ton')"
        />
      </v-col>
      <v-col>
        <v-text-field
          dense
          outlined
          hide-details="true"
          v-model="$store.state.vessel.baseForm.DWCC"
          type="number"
          :label="$t('m.dwcc')"
          :suffix="$t('m.ton')"
        />
      </v-col>
      <v-col>
        <v-text-field
          dense
          outlined
          hide-details="true"
          v-model="$store.state.vessel.baseForm.GRT"
          type="number"
          :label="$t('m.grt')"
          :suffix="$t('m.ton')"
        />
      </v-col>
      <v-col>
        <v-text-field
          dense
          outlined
          hide-details="true"
          v-model="$store.state.vessel.baseForm.NRT"
          type="number"
          :label="$t('m.nrt')"
          :suffix="$t('m.ton')"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-text-field
          dense
          outlined
          hide-details="true"
          v-model="$store.state.vessel.baseForm.Draft"
          type="number"
          :label="$t('m.draft')"
          :suffix="$t('m.meter')"
        />
      </v-col>
      <v-col>
        <v-text-field
          dense
          outlined
          hide-details="true"
          v-model="$store.state.vessel.baseForm.ShipLength"
          type="number"
          :label="$t('m.loa')"
          :suffix="$t('m.meter')"
        />
      </v-col>
      <v-col>
        <v-text-field
          dense
          outlined
          hide-details="true"
          v-model="$store.state.vessel.baseForm.Breadth"
          type="number"
          :label="$t('m.beam')"
          :suffix="$t('m.meter')"
        />
      </v-col>
      <v-col>
        <v-text-field
          dense
          outlined
          hide-details="true"
          v-model="$store.state.vessel.baseForm.Depth"
          type="number"
          :label="$t('m.depth')"
          :suffix="$t('m.meter')"
        />
      </v-col>
    </v-row>
  </v-card> <!-- 列表 row -->
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import dayjs from 'dayjs'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'

export default {
  name: 'BaseInfo',
  components: { },
  props: [
    'model', 'visible'
  ],
  data () {
    return {
      buildYearArr: []
    }
  },
  created () {
    const now = dayjs().format('YYYY')
    const yearArr = []
    for (var i = 0; i < 50; i++) {
      yearArr.push(now - i)
    }
    this.buildYearArr = yearArr
  },
  computed: {
    ...mapState({
      shipTypeArr: state => state.commons.shipTypeArr,
      countryArr: state => state.commons.countryArr,

      FOTypeArr: state => state.commons.lsfoTypeArr,
      LSFOTypeArr: state => state.commons.lsfoTypeArr,
      DOTypeArr: state => state.commons.lsdoTypeArr,
      LSDOTypeArr: state => state.commons.lsdoTypeArr
    }),

    ...mapGetters({
    })

  },
  watch: {

  },
  methods: {

    resetForm () {
    },

    clearForm () {
    }
  }

}
</script>

<style scoped>

</style>
